import type { DocumentSource } from "@gb/contracts";

/**
 * What a file that left its source is marked with (`plans/sharepoint-sync.md`
 * question 15, `plans/outlook-sync.md` question 22): where it was removed. A
 * file unpacked from another, an email's attachment or an archive's entry,
 * left with the file it came from.
 */
export function removedAtSourceLabel(source: DocumentSource): string {
  switch (source) {
    case "sharepoint":
      return "Removed in SharePoint";
    case "outlook":
      return "Removed in Outlook";
    case "attachment":
    case "archive-entry":
      return "Removed with the file it came from";
    default:
      return "Removed at its source";
  }
}
